<template>
  <li v-if="!isCuba" class="mobile-menu-header">
    <template v-if="ShowLogoPartners">
      <div class="partner-template js-partner-template">
        <img class="image-partner js-img-partner" alt="logo-partner" />
        <span class="exit-partner is-hidden" data-test="exit-partner">{{ partnerExit }}</span>
        <!-- partner -->
      </div>
    </template>
  </li>
</template>

<script>
import { IHG_API_PARAM, IHG_CMS_COOKIE, IHG_FASTBOOKING_SEARCH_PARAM } from '../../../../../src/core/utils/ihg'
import { auth0Login } from '../../../../auth0/sso'
import { isPartner, let_exit_partner } from '../../../../core/iberapi/partner_shower/partner_shower'
import loaderSpinner from '../../../../shared/loader_spinner/loader_spinner'
import { readCookie } from '../../../../utils/cookie_manager'
import MobileMenuItem from '../MobileMenuItem/MobileMenuItem'
import MobileMenuPanel from '../MobileMenuPanel/MobileMenuPanel'

const componentName = 'MobileMenuHeader'

export default {
  name: componentName,
  components: {
    MobileMenuPanel,
    MobileMenuItem,
  },
  props: {
    config: Object,
    panelTitle: String,
    //IHG
    ihgAccess: String,
    ihgCtaLogin: String,
    ihgLogo: Object,
    //Partner
    partnerExit: String,
    partnerLogo: Object,
  },
  data() {
    return {
      user: { logged_in: false },
      userIhg: { logged_in: false },
      ihgUrlLogin: '/',
    }
  },
  computed: {
    isCuba() {
      return document.documentElement.dataset.inMicrosite == 'ibercuba'
    },
    ShowOneRewards() {
      return document.body.dataset.showRewards === 'true'
    },
    getSearchIHG() {
      const urlParams = new URLSearchParams(window.location.search)

      if (urlParams.has(IHG_API_PARAM)) {
        const paramsToString = urlParams.toString()
        localStorage.setItem(IHG_FASTBOOKING_SEARCH_PARAM, paramsToString)
      }
    },
  },
  mounted() {
    IB.browsing_sessions.readRedis(this.init)

    this.ihgUrlLogin = `/${document.documentElement.getAttribute('data-js-lang')}/api/ihg/sessions/ihg_login`

    if ($.cookie('agency_user_web_name')) {
      this.user.name = $.cookie('agency_user_web_name')
      this.user.logged_in = $.cookie('agency_user_web_name')
    }

    const ihgData = readCookie(IHG_CMS_COOKIE)

    if (ihgData) {
      const userDataStr = decodeURIComponent(ihgData)
      const userData = JSON.parse(userDataStr)
      this.userIhg.logged_in = true
      const ihg_button = document.querySelector('.js-ihg-button-after-login')
      if (ihg_button) {
        this.userIhg.level = ihg_button.dataset[userData.level_code.toLocaleLowerCase()]
      } else {
        this.userIhg.level = userData.level_code
      }
      this.userIhg.levelCode = userData.level_code.toLowerCase()
    }
  },
  methods: {
    init() {
      if (IB.browsing_sessions !== null && IB.browsing_sessions.getData())
        this.user = IB.browsing_sessions.getData().redis_values
      let_exit_partner()
    },
    showLoginSSO() {
      loaderSpinner.show()
      auth0Login(false)
    },
    ShowLogoPartners() {
      isPartner()
    },
    getPanelTitle() {
      return this.panelTitle.replace(':', '')
    },
  },
}
</script>
